import React from 'react';
import { Header } from '../../components/Header';
import { Footer } from '../../components/Footer';
import { Button } from '../../components/ui/Button';
import { getProgramById } from '../../data/programs';
import { Shield, Heart, Users, Target } from 'lucide-react';
export function KidsMartialArtsPage() {
  const program = getProgramById('kids-martial-arts');
  if (!program) {
    return null;
  }
  return <div className="min-h-screen bg-white font-sans text-slate-900" data-id="element-1120">
      <Header data-id="element-1121" />

      <main className="pt-20" data-id="element-1122">
        {/* Hero Section with Background Image */}
        <section className="relative py-24 md:py-32 overflow-hidden" data-id="element-1123">
          <div className="absolute inset-0 z-0" data-id="element-1124">
            <img src={program.image} alt={program.name} className="w-full h-full object-cover" data-id="element-1125" />
            <div className="absolute inset-0 bg-gradient-to-r from-slate-900/95 via-slate-900/85 to-slate-900/75" data-id="element-1126"></div>
          </div>

          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-1127">
            <div className="max-w-3xl" data-id="element-1128">
              <h1 className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight" data-id="element-1129">
                {program.name}
              </h1>
              <p className="text-xl text-slate-200 mb-8 leading-relaxed" data-id="element-1130">
                Give your child the gift of confidence, discipline, and
                life-long skills that extend far beyond the mat.
              </p>
              <Button variant="primary" size="lg" className="text-lg" data-id="element-1131">
                Start Your Child's Journey
              </Button>
            </div>
          </div>
        </section>

        {/* Benefits Grid */}
        <section className="py-16 bg-slate-50" data-id="element-1132">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1133">
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-1134">
              <div className="text-center" data-id="element-1135">
                <div className="inline-flex items-center justify-center w-16 h-16 bg-[#dc2626] rounded-full mb-4" data-id="element-1136">
                  <Shield className="w-8 h-8 text-white" data-id="element-1137" />
                </div>
                <h3 className="text-lg font-bold text-[#1a2332] mb-2" data-id="element-1138">
                  Build Confidence
                </h3>
                <p className="text-slate-600" data-id="element-1139">
                  Watch your child stand taller and speak up with newfound
                  self-assurance
                </p>
              </div>

              <div className="text-center" data-id="element-1140">
                <div className="inline-flex items-center justify-center w-16 h-16 bg-[#dc2626] rounded-full mb-4" data-id="element-1141">
                  <Target className="w-8 h-8 text-white" data-id="element-1142" />
                </div>
                <h3 className="text-lg font-bold text-[#1a2332] mb-2" data-id="element-1143">
                  Develop Focus
                </h3>
                <p className="text-slate-600" data-id="element-1144">
                  Structured training that improves concentration and
                  goal-setting abilities
                </p>
              </div>

              <div className="text-center" data-id="element-1145">
                <div className="inline-flex items-center justify-center w-16 h-16 bg-[#dc2626] rounded-full mb-4" data-id="element-1146">
                  <Heart className="w-8 h-8 text-white" data-id="element-1147" />
                </div>
                <h3 className="text-lg font-bold text-[#1a2332] mb-2" data-id="element-1148">
                  Respect & Discipline
                </h3>
                <p className="text-slate-600" data-id="element-1149">
                  Learn to respect others, follow instructions, and develop
                  self-control
                </p>
              </div>

              <div className="text-center" data-id="element-1150">
                <div className="inline-flex items-center justify-center w-16 h-16 bg-[#dc2626] rounded-full mb-4" data-id="element-1151">
                  <Users className="w-8 h-8 text-white" data-id="element-1152" />
                </div>
                <h3 className="text-lg font-bold text-[#1a2332] mb-2" data-id="element-1153">
                  Make Friends
                </h3>
                <p className="text-slate-600" data-id="element-1154">
                  Join a supportive community where lasting friendships are
                  formed
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Main Content */}
        <section className="py-16 bg-white" data-id="element-1155">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1156">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1a2332] mb-6" data-id="element-1157">
              Why Parents Choose Che Ko for Their Kids
            </h2>

            <div className="prose prose-lg max-w-none text-slate-700 space-y-6" data-id="element-1158">
              <p data-id="element-1159">
                As a parent, you want the best for your child. You want them to
                grow up confident, focused, and equipped with the skills to
                navigate life's challenges. Our Kids Martial Arts program
                delivers exactly that—and so much more.
              </p>

              <p data-id="element-1160">
                Every class is designed with your child's development in mind.
                Through age-appropriate instruction, we teach fundamental
                martial arts techniques while building essential life skills
                like discipline, respect, and perseverance. Your child will
                learn to set goals, work hard to achieve them, and celebrate
                their progress along the way.
              </p>

              <p data-id="element-1161">
                But this isn't just about kicks and punches. It's about watching
                your child transform. Parents consistently tell us they see
                improvements in their child's behavior at home and performance
                at school. Kids become more focused during homework time, more
                respectful toward family members, and more confident in social
                situations. They learn that hard work pays off, that mistakes
                are opportunities to learn, and that they're capable of more
                than they ever imagined.
              </p>

              <p data-id="element-1162">
                Our experienced instructors create a positive, encouraging
                environment where every child feels valued and supported. We
                maintain small class sizes to ensure personalized attention, and
                our progressive curriculum means your child is always challenged
                at the right level. Whether they're naturally athletic or
                they've never tried a sport before, we meet them where they are
                and help them grow.
              </p>

              <p data-id="element-1163">
                The friendships formed in our classes often last a lifetime.
                Your child will train alongside peers who share their goals,
                creating a supportive community that celebrates each other's
                successes. They'll learn teamwork, develop social skills, and
                gain a sense of belonging that builds their self-esteem.
              </p>

              <p data-id="element-1164">
                Most importantly, you'll have peace of mind knowing your child
                is in a safe, structured environment with instructors who
                genuinely care about their development. We're not just teaching
                martial arts—we're helping shape the leaders, problem-solvers,
                and confident individuals of tomorrow.
              </p>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 bg-gradient-to-br from-[#dc2626] to-[#b91c1c] text-white" data-id="element-1165">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-1166">
            <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-1167">
              Give Your Child the Advantage They Deserve
            </h2>
            <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto" data-id="element-1168">
              Join hundreds of families who've discovered how martial arts
              training builds confident, focused, and respectful kids. Start
              with 2 weeks free—no commitment required.
            </p>
            <Button variant="secondary" size="lg" className="text-lg shadow-xl" data-id="element-1169">
              Claim Your 2 Free Weeks
            </Button>
            <p className="text-sm text-white/80 mt-4" data-id="element-1170">
              Limited spots available • Ages 6-12 • All experience levels
              welcome
            </p>
          </div>
        </section>
      </main>

      <Footer data-id="element-1171" />
    </div>;
}